// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a6276229","239":"4dda6de1","455":"993a0e01","867":"dd2127ef"}[chunkId] + ".chunk.js";
};